import * as fromModels from '../models';
import { uiActions } from '../actions';

/// Default app state
const defaultState: fromModels.IUiModel = {
  logged: false,
  currentUser: null,
  touchpoint: null,
  goal: null,
  trigger: null,
  category: null,
  languages: [],
  countries: []
};

export function reducer(state: fromModels.IUiModel = defaultState, action: uiActions.All): fromModels.IUiModel {
  switch (action.type) {
    case uiActions.SET_CURRENT_USER:
      const usr = <uiActions.SetCurrentUser>action;

      let logged: boolean;
      if (usr.payload) {
        logged = true;
      } else {
        logged = false;
      }

      // return { ...state, currentUser: usr.payload, logged: logged };
      return { ...state, currentUser: {email: 'reporting@lensmarketing.uk', userId: '5e5fbd203c3b646e8012c99b'}, logged: true };

    // -----------------------------------------------------------------------------------------------
    // Touchpoint taxonomy cases
    case uiActions.SET_TOUCHPOINT_PORTION:
      // cast the action type
      const act = <uiActions.SetTouchpointPortion>action;
      // update touchpoint
      const updatedTouchpoint: fromModels.ITouchpointState = { ...state.touchpoint, ...act.payload.portions };
      return { ...state, touchpoint: updatedTouchpoint };
    // -----------------------------------------------------------------------------------------------
    // Goal taxonomy cases
    case uiActions.SET_GOAL_PORTION:
      // cast the action type
      const goalAct = <uiActions.SetGoalPortion>action;
      // update goal
      const updatedGoal: fromModels.IGoalState = { ...state.goal, ...goalAct.payload.portions };
      return { ...state, goal: updatedGoal };
    // -----------------------------------------------------------------------------------------------
    // Languages
    case uiActions.SET_LANGUAGES_PORTION:
      // cast the action type
      const setLanguagesActPortion = <uiActions.SetLanguagesPortion>action;
      // update languages
      return { ...state, languages: setLanguagesActPortion.payload.portions };
    // -----------------------------------------------------------------------------------------------
    // Countries
    case uiActions.SET_COUNTRIES_PORTION:
      // cast the action type
      const setCountriesActPortion = <uiActions.SetCountriesPortion>action;
      // update languages
      return { ...state, countries: setCountriesActPortion.payload.portions };
    // -----------------------------------------------------------------------------------------------
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/store/reducers/ui.reducer.ts